import * as React from 'react';

import './PrimaryLayout.pcss';

interface Props {
  className?:string;
  children:any;
}

export const PrimaryLayout = (props:Props) =>
  <div style={{ maxWidth: '1200px',margin: 'auto'}}>
    <div className={`primary-layout${props.className?' '+props.className:''} content`}>{props.children}</div>
    <footer><div className={"primary-footer"}></div></footer>
  </div>
;
